module.exports = __webpack_public_path__ + "assets/img/idcard-face.e6effea5.png";